import { Component, inject, OnInit } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { Modal, ModalRef } from "@odx/angular/components/modal";

interface ConfirmModalData {
  text: string;
  headerText?: string;
  confirmButtonText?: string;
  discardButtonText?: string;
}

@Component({
  selector: "app-confirm-modal",
  templateUrl: "./confirm-modal.component.html",
  styleUrls: ["./confirm-modal.component.scss"],
  imports: [UiKitModule],
})
export class ConfirmModalComponent implements Modal<ConfirmModalData, string>, OnInit {
  public readonly modalRef = inject(ModalRef<ConfirmModalData, string>);

  text = "";
  headerText = "";
  confirmButtonText = "";
  discardButtonText = "";
  readonly isMobileConfirmModal =
    this.modalRef.id === "project-photos-confirm-modal" || this.modalRef.id === "project-files-confirm-modal";

  ngOnInit(): void {
    this.text = this.modalRef.data.text;
    this.headerText = this.modalRef.data.headerText ?? $localize`:@@modal.generalConfirmation.header:Bitte bestätigen`;
    this.confirmButtonText = this.modalRef.data.confirmButtonText ?? $localize`:@@modal.generalConfirmation.button.confirm:OK`;
    this.discardButtonText = this.modalRef.data.discardButtonText ?? "";
  }

  onConfirm() {
    this.modalRef.close("confirmed");
  }

  onDiscard() {
    this.modalRef.close("discarded");
  }
}
